import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import SEO, { breadcrumbSchema } from '../components/SEO';
import InquiryForm from '../components/InquiryForm';
import { blogPosts as mockPosts } from '../mock';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Blog = () => {
  const [posts, setPosts] = useState(mockPosts);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/blog-posts`);
        if (res.data && res.data.length > 0) setPosts(res.data);
      } catch (e) {}
    };
    fetch();
  }, []);

  return (
    <div className="min-h-screen">
      <SEO
        title="Travel & Visa Blog - Tips, Guides & Updates | Varni Visa"
        description="Travel guides, visa application tips, destination insights and travel news from Varni Visa - Surat's trusted travel consultancy."
        keywords="travel blog, visa guide, travel tips India, Varni Visa blog"
        path="/blog"
        schema={breadcrumbSchema([{name: 'Home', path: '/'}, {name: 'Blog', path: '/blog'}])}
      />
      <section 
        className="relative h-[350px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(45, 141, 180, 0.85), rgba(247, 148, 93, 0.75)), url('https://images.unsplash.com/photo-1454496406107-dc34337da8d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHx2aXNhJTIwcGFzc3BvcnR8ZW58MHx8fHwxNzgwMjM3NDg2fDA&ixlib=rb-4.1.0&q=85')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Travel Blog</h1>
          <p className="text-xl">Tips, guides, and inspiration for your travels</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
              <Card key={post.id} className="overflow-hidden hover:shadow-xl transition-all duration-300">
                <div className="h-48 overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-110 transition-transform" />
                </div>
                <CardHeader>
                  <div className="flex items-center gap-3 text-xs text-gray-500 mb-2">
                    <span className="bg-[#2D8DB4] text-white px-2 py-1 rounded">{post.category}</span>
                    <span className="flex items-center gap-1"><Calendar size={12} />{post.date}</span>
                  </div>
                  <CardTitle className="text-xl">{post.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 text-sm mb-4">{post.excerpt}</p>
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-gray-500 flex items-center gap-1">
                      <User size={12} />{post.author}
                    </span>
                    <Button variant="link" className="text-[#2D8DB4] p-0 h-auto">
                      Read More <ArrowRight size={14} className="ml-1" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {posts.length === 0 && (
            <p className="text-center text-gray-500 py-12">No blog posts yet. Check back soon!</p>
          )}
        </div>
      </section>

      {/* Inquiry */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-3xl">
          <h2 className="text-3xl font-bold text-center mb-2">Ready to Plan Your Trip?</h2>
          <p className="text-center text-gray-600 mb-8">Speak with a Varni Visa expert today</p>
          <InquiryForm showTypeSelector />
        </div>
      </section>
    </div>
  );
};

export default Blog;
